import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Refresh Farmer", -1)
const _hoisted_3 = { class: "nes-field mb-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "farmer" }, "Farmer to refresh:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  class: "mb-5 nes-btn is-primary",
  type: "submit"
}, "Refresh", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.refreshFarmer && _ctx.refreshFarmer(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          id: "farmer",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.farmer) = $event)),
          class: "nes-input"
        }, null, 512), [
          [_vModelText, _ctx.farmer]
        ])
      ]),
      _hoisted_5
    ], 32)
  ]))
}